export enum alarmActions {
    determineCoordinatesBySatellites = 'determineCoordinatesBySatellites',
    determineCoordinatesByBaseStations = 'determineCoordinatesByBaseStations',
    waitForSmsCommand = 'waitForSmsCommand',
}
